const en = {
  // Landing
  landingHeroTitle: "Spot suspicious follows. Stop guessing.",
  landingHeroSubtitle: "Find out who your partner, crush, or friends followed recently. Get alerts on new activity in a clean timeline. No login required.",
  landingHeroPlaceholder: "Enter @username to check",
  landingHeroCta: "Check profile",
  landingHowItWorks: "How it works",
  landingStep1Title: "Enter their username",
  landingStep1Body: "Just type the Instagram username you want to check.",
  landingStep2Title: "Reveal recent follows",
  landingStep2Body: "We map out their newest connections in an easy-to-read timeline.",
  landingStep3Title: "Get alerts on changes",
  landingStep3Body: "Be the first to know when they follow or unfollow someone.",
  landingComparisonTitle: "Manual checking vs. Stalkie monitoring",
  landingComparisonManual: "Manual checking",
  landingComparisonManualDesc: "Open Instagram, search the profile, scroll through their following list, try to remember who's new.",
  landingComparisonAutomated: "Stalkie monitoring",
  landingComparisonAutomatedDesc: "We detect changes automatically. New follows, unfollows, and follower changes. No manual work.",
  landingReliabilityTitle: "How does data tracking work?",
  landingReliabilityBody: "We check profile details to track follow changes. While we strive for accuracy, please keep these rules in mind:",
  landingReliability1: "We use safe updates to refresh the tracking timeline",
  landingReliability2: "Private profiles cannot be monitored at all",
  landingReliability3: "Instagram updates may temporarily affect checking frequency",
  landingReliability4: "We only show new follows and unfollows detected after tracking begins",
  landingReliabilityCta: "We guarantee 100% anonymity: the target profile will never know you checked.",
  landingFaqTitle: "Frequently asked questions",
  landingFaq1Q: "Do I need to log in with Instagram?",
  landingFaq1A: "No. Stalkie works 100% anonymously and independently. You never need to provide your password or connect your account.",
  landingFaq2Q: "Can I monitor private profiles?",
  landingFaq2A: "No. We only track public Instagram profiles. Private profiles cannot be monitored, and we respect Instagram's privacy settings.",
  landingFaq3Q: "How often is data updated?",
  landingFaq3A: "We check profiles regularly based on your chosen subscription and send alerts when changes are detected.",
  landingFaq4Q: "Can I see historical data before I start monitoring?",
  landingFaq4A: "You can see a preview of who they currently follow. Historical tracking and change alerts only start after you begin monitoring.",
  landingFaq5Q: "Will they know I am tracking them?",
  landingFaq5A: "No. All checks are performed anonymously on our servers. The target profile will never receive any notification or alert.",
  landingCtaTitle: "Ready to know the truth?",
  landingCtaBody: "Enter their username below to reveal recent follow changes and catch suspicious activity.",
  landingDisclaimer: "Stalkie is not affiliated with Instagram or Meta. We only access publicly available information.",

  // Search
  searchTitle: "Tracking connections",
  searchSubtitle: "Checking recent history for @%{handle}",
  previewAnalyzingTitle: "Analyzing follows",
  previewProgressLabel: "Progress",
  searchLoading1: "Preparing secure connection...",
  searchLoading2: "Locating profile...",
  searchLoading3: "Analyzing profile...",
  searchLoading4: "Building your report...",
  searchLoading5: "Finalizing secure preview...",
  searchErrorInvalid: "Invalid Instagram handle. Handles use letters, numbers, underscores, and periods.",
  searchErrorEmpty: "Please enter an Instagram handle.",
  searchErrorProvider: "Our data provider is temporarily unavailable. Please try again later.",
  searchErrorRateLimit: "Too many requests. Please wait a moment and try again.",
  searchErrorNotFound: "Profile not found. Check the handle and try again.",
  searchErrorGeneric: "Something went wrong. Please try again.",
  validationEmpty: "Please enter an Instagram handle.",
  validationInvalidProviderUrl: "Use an instagram.com profile URL or a username.",
  validationInvalidUrl: "Use a valid Instagram profile URL or username.",
  validationSpacesOrAt: "Usernames cannot contain spaces or extra @ symbols.",
  validationLengthOrChars: "Use 1-30 letters, numbers, underscores or dots.",
  downloadIos: "Download for iOS",
  downloadAndroid: "Download for Android",
  scanToDownload: "Scan to download",

  // Profile preview
  previewTitle: "@%{handle}",
  previewPublicAvailable: "Profile available — Tracking ready",
  previewPrivateNotAvailable: "Private profile — cannot be monitored",
  previewNotFound: "Profile not found",
  previewPrivateNote: "Unlike other apps, Stalkie does not access private Instagram accounts and that's by design.",
  previewNotFoundBody: "Check the handle spelling and try again. Make sure it's a valid Instagram username.",
  previewFollowingCount: "%{count} following",
  previewFollowersCount: "%{count} followers",
  previewVerified: "Verified",
  previewLastChecked: "Last checked: %{time}",
  previewReliabilityLabel: "Data confidence: %{level}",
  previewBaselineTitle: "Recent connections",
  previewBaselineBody: "These are some of the profiles they currently follow.",
  previewLockedTitle: "Unlock follow monitoring",
  previewLockedBody: "Subscribe to monitor this profile. You'll get instant alerts on your phone when they follow or unfollow someone.",
  previewLockedCta: "See plans",
  previewNoDataTitle: "No data available yet",
  previewNoDataBody: "We couldn't retrieve data for this profile. It may be private or temporarily unavailable.",
  previewWhatYouGet: "What you get with monitoring:",
  previewFeature1: "Automatic detection of new follows",
  previewFeature2: "Automatic detection of unfollows",
  previewFeature3: "Timeline organized by date",
  previewFeature4: "Automatic change alerts",
  previewFeature5: "Gender analysis of new follows",
  previewMonitoringStartsAfter: "Historical tracking begins after you start monitoring. Past changes are not available.",
  previewWhatDoYouThink: "What do you think? 🤔",
  previewRecentlyFollowed: "%{name} recently followed",
  previewGirlsCount: "%{count} girls",
  previewGirlCount: "%{count} girl",
  previewGuysCount: "%{count} guys",
  previewGuyCount: "%{count} guy",
  previewOthersCount: "%{count} others",
  previewOtherCount: "%{count} other",
  previewUnlockNow: "Unlock Now",
  previewAuthenticatedTitle: "Ready to monitor",
  previewAuthenticatedBody: "Add this profile to your monitoring and get alerts when something changes.",
  previewAddMonitoring: "Add monitoring",
  previewContinueToReview: "Continue",
  searchPageKicker: "Public profile preview",
  searchPageSubtitle: "Search any public Instagram handle to preview profile availability before unlocking monitoring.",
  searchPageEnterHandle: "Enter a handle to start",
  searchPageEnterHandleDesc: "Use the search above to check a public profile and view a locked preview.",
  searchPageValidating: "Validating @%{handle} before checking public data.",
  previewingHandle: "Previewing @%{handle}",
  previewPageSubtitle: "Keep searching public profiles and compare previews before subscribing.",
  
  reliability_reliable: "Profile available",
  reliability_reliable_desc: "This profile is public and ready to be monitored.",
  reliability_probably_reliable: "Profile available",
  reliability_probably_reliable_desc: "This profile is public and ready to be monitored.",
  reliability_confirmation_required: "Checking profile",
  reliability_confirmation_required_desc: "Verifying profile status and recent updates.",
  reliability_degraded: "Profile available",
  reliability_degraded_desc: "This profile is public and ready to be monitored.",
  reliability_incomplete_data: "No data available",
  reliability_incomplete_data_desc: "We couldn't retrieve enough information for this profile.",
  reliability_provider_error: "Temporarily unavailable",
  reliability_provider_error_desc: "The search is temporarily unavailable. Please try again later.",
  reliability_private_profile: "Private profile",
  reliability_private_profile_desc: "This profile is private and cannot be monitored.",
  reliability_paused_unreliable: "Unavailable",
  reliability_paused_unreliable_desc: "Monitoring is currently unavailable.",
  reliability_unknown: "Checking status",
  reliability_unknown_desc: "Checking profile status.",

  // Paywall
  paywallTitle: "Unlock monitoring for @%{handle}",
  paywallSubtitle: "Get real-time alerts whenever this profile follows or unfollows someone.",
  paywallPlanWeekly: "Weekly",
  paywallPlanMonthly: "Monthly",
  paywallBestValue: "Best value",
  paywallTitleTarget: "Continue tracking @%{handle}",
  paywallSubtitleTarget: "Get alerts when @%{handle} follows someone new. We keep tracking so you don't have to check manually.",
  paywallProfilesFollowing: "Profiles @%{handle} follows",
  paywallFeaturePrivateTitle: "100% private & secure",
  paywallFeaturePrivateDesc: "No Instagram login required",
  paywallFeatureRecentTitle: "View recent follows in order",
  paywallFeatureRecentDesc: "See exactly who they followed, sorted by date",
  paywallFeatureNotifiedTitle: "Get notified of every change",
  paywallFeatureNotifiedDesc: "New follow & follower alerts instantly",
  paywallTrusted: "Trusted by 1M+ users",
  paywallCancelAnytime: "Cancel anytime, no commitments",
  paywallNotNow: "Not now",
  paywallPlanWeeklyDesc: "Lowest commitment, full access",
  paywallPlanMonthlyDesc: "Same features, for longer",
  paywallMonitorLimit: "Up to %{count} profiles",
  paywallCta: "Start monitoring",
  paywallRestore: "Restore purchase",
  paywallRestoring: "Restoring...",
  paywallRestoreSuccess: "Purchase restored. Your subscription is active.",
  paywallRestoreNotFound: "No active purchase was found for this account.",
  paywallRestoreError: "Could not restore purchase. Try again.",
  paywallTerms: "By continuing, you agree to our Terms of Use and Privacy Policy.",
  paywallBillingNote: "Recurring billing. Cancel anytime.",
  paywallPerDay: "Less than %{price} per day",

  paywallBillingPeriodWeekly: "week",
  paywallBillingPeriodMonthly: "month",
  paywallErrorStartMonitoring: "Couldn't start monitoring. Please try again.",
  paywallErrorLoad: "Couldn't load plans. Please try again.",
  paywallActivatingPlan: "Activating your plan...",
  paywallMonitorSetupFailedTitle: "Monitoring was not started",
  paywallMonitorSetupFailedBody: "Your plan is active, but we could not start monitoring this profile. Try again.",
  paywallProcessingPaymentTitle: "Processing payment...",
  paywallProcessingPaymentBody: "Your payment may take a moment to process. If you are not redirected, check your email for a receipt.",
  paywallSuccessTitle: "All set",
  paywallSuccessBody: "Taking you to your dashboard...",
  paywallSettingUpProfile: "Starting monitoring for @%{handle}...",
  billingContinueInAppTitle: "Continue in the Stalkie app",
  billingContinueInAppBody: "Web search checks profile availability. In the Stalkie app, you can keep monitoring profiles and receive follow and unfollow alerts.",

  // Monitoring status
  monitoringActive: "Active",
  monitoringPaused: "Paused",
  monitoringPrivate: "Private",
  monitoringRateLimited: "Rate limited",
  monitoringDisabled: "Disabled",
  monitoringPendingFirstSync: "Waiting for first sync",
  monitoringDegraded: "Degraded",
  monitoringError: "Error",
  monitoringNextUpdate: "Next update: %{time}",

  // Timeline events
  timelineStartedFollowing: "Started following",
  timelineStoppedFollowing: "Unfollowed",
  timelineGainedFollower: "New follower",
  timelineLostFollower: "Lost follower",
  timelinePendingConfirmation: "Pending confirmation",
  timelineLowConfidence: "Low confidence",
  timelineDiscarded: "Discarded",
  timelineNoEvents: "No events yet",
  timelineNoEventsHint: "Events appear here once monitoring detects changes.",
  timelineEventsRetention: "Events are kept for up to 90 days.",
  timelineMonitoringStarted: "Monitoring started",
  timelineDataGap: "Data gap — no reliable data for this period",

  // App shell
  appDashboard: "Overview",
  appProfiles: "Profiles",
  appTimeline: "Timeline",
  appBilling: "Billing",
  appAccount: "Settings",
  appNotifications: "Notifications",
  notificationsEmptyTitle: "You're all caught up",
  notificationsEmptyBody: "New follow activity will appear here.",
  notificationsUnavailableTitle: "Notifications are temporarily unavailable.",
  notificationsUnavailableBody:
    "Your account is still safe. Return to the dashboard and try again in a moment.",
  notificationsBackToDashboard: "Back to dashboard",
  settingsEmailNotifications: "Email fallback",
  settingsEmailNotificationsDesc: "Receive an email if browser push is unavailable.",
  notificationsMarkAllRead: "Mark all as read",
  appNavigation: "App navigation",
  appSignOut: "Sign out",

  // Dashboard
  dashboardTitle: "Monitored profiles",
  dashboardOverviewTitle: "Spot suspicious follows",
  dashboardEyebrow: "Follow alerts",
  dashboardOverviewSubtitle: "Add a public Instagram profile to reveal recent follows, track unfollows, and get alerts.",
  dashboardMonitoringChip: "Monitoring",
  dashboardEmpty: "Spot suspicious follows. Stop guessing.",
  dashboardEmptyHint: "Add a public Instagram profile to monitor new follows and unfollows. No Instagram password required.",
  dashboardEmptyProof: "100% Anonymous",
  dashboardFeatureNewFollows: "New follows detected",
  dashboardFeatureUnfollows: "Unfollows detected",
  dashboardAddProfile: "Add profile",
  dashboardAccountLimit: "%{current}/%{limit} profiles",
  dashboardUpgradeCta: "Upgrade to add more",
  renewalTitle: "Reactivate monitoring",
  renewalDescription: "Your previous plan is no longer active. Renew to add profiles and keep monitoring changes.",
  renewalCta: "Renew plan",
  onboardingTargetTitle: "Which profile do you want to monitor?",
  addTargetSubtitle: "Paste a username or Instagram profile URL. Stalkie only monitors public profiles and starts tracking from this moment forward.",
  addTargetModalTitle: "Confirm",
  addTargetClipboardPaste: "Paste @%{handle}",
  addTargetPrivateError: "This profile is private. Stalkie only monitors public Instagram profiles.",
  loadingAddMonitorTitle: "Adding profile",
  loadingAddMonitorSubtitle: "Preparing monitoring...",
  loadingAddMonitorStep1: "Checking profile",
  loadingAddMonitorStep2: "Starting monitoring",
  loadingAddMonitorStep3: "Finishing setup",
  // Billing
  billingTitle: "Subscription",
  billingCurrentPlan: "Current plan",
  billingFree: "Free",
  billingManage: "Manage subscription",
  billingExpiresAt: "Renews or expires on %{date}",
  billingSignInTitle: "Sign in to manage billing",
  billingSignInBody: "Create an account to subscribe and start monitoring profiles.",
  billingNoSubscription: "No active subscription",
  billingCheckoutError: "Could not open the payment page. Try again.",
  billingPortalError: "Could not open subscription management. Try again.",
  billingRenewKicker: "Plan required",
  billingRenewTitle: "Keep monitoring active",
  billingRenewTitleTarget: "Start monitoring @%{handle}",
  billingRenewBody: "Choose a plan to add profiles, receive alerts, and keep monitoring running.",
  billingRenewBodyTarget: "Choose a plan to add @%{handle} and start tracking new follows from now on.",
  billingRenewIntro: "Monitoring is available only after an active plan. Your account stays ready; pick a plan to unlock profile tracking again.",
  billingRenewIntroTarget: "After payment, @%{handle} goes straight into monitoring.",
  billingIncluded: "Included",
  billingFeatureAnonymous: "Anonymous monitoring",
  billingFeatureAlerts: "Follow and unfollow alerts",
  billingFeatureDirect: "Direct profile add",
  billingPlanWeeklyMeta: "Up to %{count} profiles, billed weekly",
  billingPlanMonthlyMeta: "Up to %{count} profiles, billed monthly",
  billingStartTarget: "Start @%{handle}",
  statusActive: "Active",

  // Account
  accountTitle: "Account",
  settingsTitle: "Settings",
  settingsNotifications: "Notifications",
  settingsNotificationsDesc: "Get alerts for new follows and unfollows",
  settingsSupport: "Support",
  settingsHelp: "Help Center",
  settingsReport: "Report a Problem",
  settingsAbout: "About",
  settingsUserId: "User ID",
  settingsVersion: "Version",
  settingsLegal: "Legal",
  settingsTerms: "Terms of Use",
  settingsPrivacy: "Privacy Policy",
  settingsDeleteAccount: "Delete Account",
  settingsDeleteAccountDesc: "This action is irreversible",
  settingsCopied: "Copied",
  accountNotificationsSaved: "Notification settings updated.",
  accountNotificationsError: "Could not update notification settings. Try again.",
  accountNotificationsBlocked: "Notifications are blocked by your browser. Please enable them in your browser settings.",
  accountNotificationsNotSupported: "Push notifications are not supported by this browser.",
  accountCopyError: "Could not copy the user ID in this browser.",
  accountDeleteError: "Could not delete the account. Try again or contact support.",
  accountDeleteSubscriptionWarning: "Deleting your account does not cancel your active subscription.",
  accountLanguage: "Language",
  accountLanguagePt: "Português",
  accountLanguageEn: "English",
  accountLanguageEs: "Español",
  accountSignInTitle: "Sign in to manage your account",
  accountSignInBody: "Create an account to get started.",
  accountSession: "Session",
  accountCreated: "Created %{date}",
  accountDeleteBtn: "Delete account",
  accountDeleteConfirmText: "This action is irreversible. All your monitoring data will be deleted.",
  accountDeleteConfirmBtn: "Confirm delete",
  accountCancel: "Cancel",
  accountSubscriptionStatus: "Status: %{status}",
  accountSubscriptionLimit: "Profile limit: %{count}",

  // Dashboard Page additions
  dashboardErrorLoad: "Failed to load monitored profiles.",
  dashboardSignInTitle: "Sign in to view your dashboard",
  dashboardSignInBody: "Create an account to start monitoring profiles.",

  // Profile Detail Page additions
  profileDetailRemoved: "This profile may have been removed.",
  profileDetailRemoveBtn: "Remove monitoring",
  tabFollows: "New follows",
  statNew: "New",
  tabUnfollows: "Unfollows",
  monitorDetailsMonitoringStarted: "Monitoring active",
  monitorDetailsMonitoringStartedHint: "New follows will appear here as soon as Stalkie detects a reliable change.",
  monitorDetailsRecentActivity: "Recent activity",
  monitorDetailsPrivateWaiting: "This profile is private now. Stalkie keeps the monitor paused until the account becomes public again.",
  monitorDetailsDeleteDescription: "This removes the profile from your monitored list. Existing monitoring data for this profile will be deleted.",
  monitorDetailsDeleteConfirm: "Delete",
  monitorDetailsDeleteError: "Couldn't remove this monitor. Please try again.",
  emptyUnfollows: "No unfollows detected yet",
  activityHoursTitle: "Activity pattern",

  // Timeline Filter additions
  timelineFilterAll: "All",
  timelineFilterFollows: "Follows",
  timelineFilterUnfollows: "Unfollows",

  // Common
  commonBack: "Back",
  commonClose: "Close",
  commonLoading: "Loading...",
  commonError: "Something went wrong",
  commonRetry: "Try again",
  commonLoadMore: "Load more",
  profileUpdatedAt: "Updated %{time}",
  commonNever: "never",
  commonJustNow: "just now",
  commonMinutesAgo: "%{minutes}m ago",
  commonHoursAgo: "%{hours}h ago",
  commonDaysAgo: "%{days}d ago",
  commonFollowing: "following",
  commonFollowers: "followers",

  // Empty / error states
  emptyProfilesTitle: "No profiles to show",
  emptyProfilesBody: "You haven't added any profiles to monitor yet.",
  errorGenericTitle: "Something went wrong",
  errorGenericBody: "An unexpected error occurred. Please try again.",
  errorNetworkTitle: "Connection issue",
  errorNetworkBody: "Please check your internet connection and try again.",

  // Login
  loginBackToHome: "← Back to home",
  loginWelcomeBack: "Welcome back",
  loginSubtitle: "Log in to see your tracked profiles, recent changes, and alerts.",
  loginEmailLabel: "Email address",
  loginEmailPlaceholder: "you@example.com",
  loginSendingCode: "Sending code…",
  loginContinueBtn: "Continue with email",
  loginFooterNote: "Use the same email connected to your Stalkie app. We'll send you a one-time code — no password needed.",
  loginBack: "Back",
  loginCheckEmail: "Check your email",
  loginSentCodeTo: "We sent a 6-digit code to",
  loginLoggingIn: "Logging in…",
  loginResendCode: "Resend code",
  loginSendAgain: "Send again",
  loginNeedHelp: "Need help?",
  loginContactSupport: "Contact support",
  loginErrorSend: "We couldn't send your code. Check your email and try again.",
  loginErrorVerify: "That code didn't work. Check the code and try again.",
  loginErrorResend: "Failed to resend. Try again.",
  loginSubmitBtn: "Log in",

  // 404
  notFoundTitle: "This page doesn't exist.",
  notFoundGoHome: "Go home",

  // Parity / Dossier keys
  dossierTitle: "Profile Details",
  dossierMutual: "Mutual follow — they follow each other",
  dossierFollowers: "Followers",
  dossierFollowing: "Following",
  dossierPrivate: "Private Profile",
  dossierPublic: "Public Profile",
  dossierViewOnInstagram: "View on Instagram",
  genderBreakdownTitle: "Recent follows breakdown",
  genderBreakdownText: "Recently followed: %{female} girls, %{male} guys, %{unknown} others",
  genderBreakdownFemale: "%{count} girls",
  genderBreakdownMale: "%{count} guys",
  genderBreakdownUnknown: "%{count} others",
  genderBreakdownNone: "No follows detected yet",
  mutualBadge: "Mutual",
  dossierCategoryPersonal: "Personal Account",
  dossierCategoryInfluencer: "Influencer",
  dossierCategoryCreator: "Creator",
  dossierCategoryBrand: "Brand / Business",
};

export default en;
